import { render, staticRenderFns } from "./ConfigurazionePazientiMenuEdit.vue?vue&type=template&id=0170bef9"
import script from "./ConfigurazionePazientiMenuEdit.vue?vue&type=script&lang=js"
export * from "./ConfigurazionePazientiMenuEdit.vue?vue&type=script&lang=js"
import style0 from "./ConfigurazionePazientiMenuEdit.vue?vue&type=style&index=0&id=0170bef9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports